import { createTheme, Theme, ThemeOptions } from '@mui/material/styles'
import * as _ from 'lodash'

export const extendMuiTheme = (prevTheme: Theme, extensionTheme: ThemeOptions) => {
    return createTheme(_.merge({}, prevTheme, extensionTheme))
}
